/** Keeps Sonner's expanded-stack offsets in sync with locally animated card content. */
const setStyleProperty = (element: HTMLElement, property: string, value: string) => {
    if (element.style.getPropertyValue(property) !== value) {
        element.style.setProperty(property, value);
    }
};

export const syncPlatformToastStackMeasurements = (host: HTMLElement) => {
    host.querySelectorAll<HTMLElement>('[data-sonner-toaster]').forEach((list) => {
        const gap = Number.parseFloat(getComputedStyle(list).getPropertyValue('--gap')) || 8;
        const toasts = Array.from(list.querySelectorAll<HTMLElement>(':scope > [data-sonner-toast]'))
            .filter((toast) => toast.dataset.removed !== 'true')
            .sort((left, right) => Number(left.dataset.index ?? 0) - Number(right.dataset.index ?? 0));
        let offset = 0;

        toasts.forEach((toast, index) => {
            const card = toast.querySelector<HTMLElement>('.platform-toast');
            const height = card?.getBoundingClientRect().height ?? toast.scrollHeight;

            setStyleProperty(toast, '--initial-height', `${height}px`);
            setStyleProperty(toast, '--offset', `${offset}px`);

            if (index === 0) {
                setStyleProperty(list, '--front-toast-height', `${height}px`);
            }

            offset += height + gap;
        });
    });
};
